import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { LocalDataStoreService } from "src/app/core/services/local-data-store.service";
import { UserService } from "src/app/core/services/user.service";
import { UserStatusEnum } from "src/app/shared/models/enums/user-status.enum";
import { User } from "src/app/shared/models/user.model";

@Component({
	selector: "app-user-claim",
	templateUrl: "./user-claim.component.html",
	styleUrls: ["./user-claim.component.scss"],
})
export class UserClaimComponent implements OnInit {
	errorCondition: string = undefined;
	password = {
		password: undefined,
		confirmPassword: undefined,
	};
	step: number = 0;
	userKey: string;
	user: User;

	constructor(
		public app: AppService,
		private localStorage: LocalDataStoreService,
		private focuslink: FocuslinkService,
		private route: ActivatedRoute,
		private router: Router,
		private userService: UserService
	) {}

	ngOnInit(): void {
		this.route.queryParams.subscribe((params) => {
			this.userKey = params["k"];
		});
		if (this.userKey !== undefined) {
			this.init();
		} else {
			this.step = 999;
		}
	}

	async init() {
		await this.getUser(this.userKey);
	}

	async claimAccount() {
		const resp = await this.focuslink.userClaim(this.user.key, this.password.password);
		this.user = new User(resp);
		this.app.msgSvc.add({ severity: "success", summary: "Account claimed." });
		this.step = 2;
	}

	async login() {
		const resp = await this.focuslink.userLogIn(this.user.email, this.password.password);
		this.user = new User(resp.user);
		await this.localStorage.set("user", this.user);
		await this.userService.initUser(this.user, resp.token);
		this.router.navigate(["cc/dashboard"]);
	}

	async getUser(key: string) {
		try {
			const resp = await this.focuslink.userGet(key);
			this.user = new User(resp);
			switch (this.user.status) {
				case UserStatusEnum.PENDING:
					this.step = 1;
					break;
				case UserStatusEnum.ACTIVE:
					this.step = 3;
					break;
				case UserStatusEnum.FROZEN:
					this.step = 4;
					this.errorCondition = "User Account Frozen";
					break;
				case UserStatusEnum.DELETED:
					this.step = 4;
					this.errorCondition = "User Account Deleted";
					break;
				default:
					this.step = 4;
					this.errorCondition = "0X 68 65 63 6b 20 69 66 20 49 20 6b 6e 6f 77 2e 20 49 74 27 73 20 6a 75 73 74 20 61 6e 20 65 72 72 6f 72";
					break;
			}
		} catch (error) {
			console.log(error);
			this.app.msgSvc.add({ severity: "error", detail: error.error });
			this.errorCondition = error.error;
			this.step = 4;
		}
	}
}
